import { NgModule } from '@angular/core'
import { KeywordFormComponent } from './keyword-form.component'
import { MultipassKeywordFormComponent } from './multipass-keyword-form.component'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { EditorModule } from '@tinymce/tinymce-angular'
import { DatetimePickerModule } from '../../datetime-picker/datetime-picker.module'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { NgxFileDropModule } from 'ngx-file-drop'
import { PluralizeModule } from '../../../pipes/pluralize/pluralize.module'
import { PopCardModule } from '../../pop-card/pop-card.module'
import { OutsideClickModule } from '../../../directives/outside-click/outside-click.module'
import { AccordionFadeModule } from '../../accordion-fade/accordion-fade.module'
import { RedDotModule } from '../../red-dot/red-dot.module'
import { WriterAvatarModule } from '../../writer-avatar/writer-avatar.module'
import { KeywordMutations } from '../../../graphql/mutations/keyword.mutations'
import { RequestMutations } from 'graphql/mutations/request.mutations'
import { FilterPreferredWriters } from 'modules/keywords/pipes/filter-preferred-writers.pipe'
import { FilterContents } from 'modules/keywords/pipes/filter-contents.pipe'
import { SeoRequirementsComponent } from 'modules/keywords/keyword-form/seo-requirements.component'
import { DirectAssignmentComponent } from 'modules/keywords/keyword-form/direct-assignment.component'
import { DeadlineComponent } from 'modules/keywords/keyword-form/deadline.component'
import { MultipassSeoRequirementsComponent } from 'modules/keywords/keyword-form/multipass-seo-requirements.component'
import { MultipassDirectAssignmentComponent } from 'modules/keywords/keyword-form/multipass-direct-assignment.component'
import { MultipassWordLengthDropdownComponent } from 'modules/keywords/keyword-form/multipass-word-length-dropdown/multipass-word-length-dropdown.component'
import { MultipassDeadlineComponent } from 'modules/keywords/keyword-form/multipass-deadline.component'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { FileManagerComponent } from 'modules/keywords/keyword-form/file-manager.component'
import { MultipassFileManagerComponent } from './multipass-file-manager.component'
import { AutofocusDirectiveModule } from 'src/directives/autofocus/autofocus.module'
import { WritersListComponent } from './writers-list.component'
import { ContentsListComponent } from './multipass-word-length-dropdown/contents-list.component'
import { QuantitySelectorModule } from '../../quantity-selector/quantity-selector.module'
import { ModalModule } from 'src/modules/modal/modal.module'


@NgModule({
  declarations: [
    KeywordFormComponent,
    MultipassKeywordFormComponent,
    FilterPreferredWriters,
    FilterContents,
    SeoRequirementsComponent,
    DirectAssignmentComponent,
    DeadlineComponent,
    FileManagerComponent,
    MultipassFileManagerComponent,
    WritersListComponent,
    ContentsListComponent,
    MultipassSeoRequirementsComponent,
    MultipassDirectAssignmentComponent,
    MultipassWordLengthDropdownComponent,
    MultipassDeadlineComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    EditorModule,
    DatetimePickerModule,
    BsDropdownModule,
    PopoverModule,
    NgxFileDropModule,
    PluralizeModule,
    PopCardModule,
    OutsideClickModule,
    AccordionFadeModule,
    WriterAvatarModule,
    TooltipModule,
    AutofocusDirectiveModule,
    RedDotModule,
    QuantitySelectorModule,
    ModalModule
  ],
  exports: [
    KeywordFormComponent,
    MultipassKeywordFormComponent
  ],
  providers: [
    KeywordMutations,
    RequestMutations,
    FilterContents
  ]
})
export class KeywordFormModule {}
